module.exports = __webpack_public_path__ + "img/character-random-bg.6d3cf4ce.png";